// test2473
(2473 && 0);
